export enum ResearchTypeTitle {
  Report = 'Report',
  AnalystNote = 'Analyst Note',
  MgmtQs = 'Mgmt Qs',
}
